/**
* 订单管理 交易订单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>账户管理</el-breadcrumb-item>
      <el-breadcrumb-item>钱包管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item v-if="user.username == 'admin'" label="选择部门">
        <el-select v-model="formInline.pid" placeholder="请选择部门" size="small" @change="getData">
          <el-option v-for="item in deptList" :key="item.id" :label="item.departmentName" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>

          <el-date-picker value-format="yyyy-MM-dd" size="small" v-model="dataStr" type="daterange" range-separator="至" start-placeholder="开始日期"
            @change="getDate" end-placeholder="结束日期">
          </el-date-picker>

      </el-form-item>



      <el-form-item>
        <el-button size="small" type="success" :loading="downloadJlLoadin" @click="exportJldata" >导出</el-button>
        <el-button size="small" type="primary" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;" :header-cell-style="this.$store.state.headerCss" :max-height="tableHeight">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>

      <el-table-column prop="walletName" label="用能单元" sortable show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="concatName"  label="客户名称" sortable show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="concatMobile" label="联系电话" width="120" sortable show-overflow-tooltip>
      </el-table-column>

      <el-table-column  prop="electric" label="用电量" >
      </el-table-column>
      <el-table-column  prop="electricAmount" label="电费" >
      </el-table-column>
      <el-table-column  prop="water" label="用水量" >
      </el-table-column>
      <el-table-column  prop="waterAmount" label="水费" >
      </el-table-column>
      <el-table-column  prop="beginDate" label="开始时间" >
      </el-table-column>
      <el-table-column  prop="endDate" label="结束时间" >
      </el-table-column>



     <!-- <el-table-column align="center" label="操作" width="420">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="success" @click="handelBindUser(scope.row)">绑定用户</el-button>
          <el-button size="mini" type="success" @click="handelBindMeter(scope.row)">绑定计量点</el-button>
          <el-button size="mini" type="primary" @click="handleRecharge(scope.row,'充值')">充值</el-button>
          <el-button size="mini" type="warning" @click="handleRecharge(scope.row,'退款')">退款</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="formInline" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
  import {
    getWalletBill,
    getWalletBillPoiFiter
  } from '../../api/payMG'

  import {getDepartmentTerminalInfoLis} from '../../api/energyMG.js'
  import {timestampToTime} from '@/utils/util'
  import Pagination from '../../components/Pagination'
  export default {
    data(){
      return {
        formInline: {
          pid: '',
          dataTime: "",
          endDate: "",
          currentPage:1,
          pageSize:10,
          total:0
        },
        tableHeight: 0,
        user:{},
        dataStr:[],
        deptList:[],
        title: "",
        dataList: [],
        loading: false,
        editFormVisible: false,
        downloadJlLoadin:false,
      }
    },
    // 注册组件
    components: {
      Pagination
    },


    created() {
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      this.formInline.pid = this.user.departmentId
      let d = new Date()
      this.formInline.dataTime = d.getFullYear()+ '-'+( d.getMonth()+1 < 10 ? '0':'' ) +  (d.getMonth()+1) + '-' + '01'
      this.formInline.endDate = d.getFullYear()+ '-'+( d.getMonth()+1 < 10 ? '0':'' ) + (d.getMonth()+1) + '-' + ( d.getDate() < 10 ? '0':'' ) + d.getDate()
      this.dataStr = [ this.formInline.dataTime,this.formInline.endDate ]
      this.getData()
      this.getJzData()
    },
    mounted() {
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight - 240
      })
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {

      callFather(parm ){
        this.formInline.currentPage = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getData()
      },

      getJzData: function() {
        return new Promise((resolve, reject) => {
          getDepartmentTerminalInfoLis().then(res => {
            this.treeLoad = false
            if (res.status == 1) {
              let arr = []
              this.deptList = res.data.menuDepList
            } else {
              this.$message.error(res.msg)
            }
          })
        })
      },
      getData() {
        this.loading = true
        getWalletBill(this.formInline)
          .then(res => {
            this.loading = false
            if (res.status == 1) {
              this.dataList = res.data.content
              this.formInline.total = res.data.totalElements
            } else {

            }
          })

      },

      // 搜索事件
      search() {
        this.getData()
      },
      getDate(val) {

        // this.formInline.dataTime = timestampToTime(this.dataStr[0]).substring(0, 10)
        // this.formInline.endDate = timestampToTime(this.dataStr[1]).substring(0, 10)

        this.formInline.dataTime = val[0]
        this.formInline.endDate = val[1]

        this.search()

      },

      exportJldata() {
        this.downloadJlLoadin = true



        getWalletBillPoiFiter(this.formInline).then(res => {


          var blob = new Blob([res], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
          }); //type这里表示xlsx类型
          var downloadElement = document.createElement('a');
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = '交易记录.xls'; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.downloadJlLoadin = false
          this.$message.success('表格生成成功！正在下载')
        }).catch(err => {
          this.downloadJlLoadin = false
          this.$message({
            message: '下载失败！',
            type: 'error',
            showClose: true
          })
        })
      },




      // 关闭编辑、增加弹出框
      closeDialog(formName) {
        this.editFormVisible = false
        this.$refs[formName].resetFields()
      }


    }
  }
</script>

<style scoped>
  .user-search {}

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/account/walletBill.vue